import styled from 'styled-components';

export const StyledGraphicImage = styled.img`
  max-height: 155px;
`;

export default StyledGraphicImage;
